export default __webpack_public_path__ + "static/media/chetan-compressed.818d63ca.jpg";